var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "community" },
    [
      _c("div", { staticClass: "o-wrapper" }, [
        _c("div", { staticClass: "o-grid" }, [
          _c("div", { staticClass: "o-grid__item u-width-full" }, [
            _c("div", { staticClass: "community__wrap" }, [
              _c("div", { staticClass: "community__details" }, [
                _c(
                  "div",
                  {
                    class: [
                      "community__logo",
                      _vm.$root.community.isMember ? "member" : "",
                    ],
                  },
                  [
                    _c("img", {
                      attrs: {
                        srcset: _vm.communityLogoSrcSet,
                        src: _vm.communityLogo,
                        alt: _vm.$root.community.name,
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "community__content" }, [
                  _c("h5", [_vm._v(_vm._s(_vm.$root.community.name))]),
                  _vm._v(" "),
                  _c("div", { staticClass: "community__info" }, [
                    _c("div", { staticClass: "community__stat" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "19",
                            height: "20",
                            viewBox: "0 0 19 20",
                            fill: "none",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "9.5",
                              cy: "5.5",
                              r: "4.75",
                              stroke: "black",
                              "stroke-width": "1.5",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M1.44689 16.3762C2.78824 13.05 5.90339 10.75 9.5 10.75C13.0966 10.75 16.2118 13.05 17.5531 16.3762C17.8478 17.107 17.6742 17.7862 17.2018 18.3182C16.713 18.8686 15.9029 19.25 15 19.25H4C3.09714 19.25 2.287 18.8686 1.79822 18.3182C1.32581 17.7862 1.15219 17.107 1.44689 16.3762Z",
                              stroke: "black",
                              "stroke-width": "1.5",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$simpleStore.formatValue(
                              _vm.$root.community.members
                            )
                          ) + " member"
                        ),
                        _vm.$root.community.members !== 1
                          ? _c("span", [_vm._v("s")])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.$root.community.isMember === false
                      ? _c(
                          "a",
                          {
                            class: ["button__join"],
                            attrs: { "data-cy": "join-community", href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.join.apply(null, arguments)
                              },
                            },
                          },
                          [_c("p", [_vm._v("Join")])]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$root.community.isMember
                      ? _c(
                          "a",
                          {
                            staticClass: "button__status",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.toggleModalLeave.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "72",
                                  height: "32",
                                  viewBox: "0 0 72 32",
                                  fill: "none",
                                },
                              },
                              [
                                _c("rect", {
                                  attrs: {
                                    width: "72",
                                    height: "32",
                                    rx: "16",
                                    fill: "#47AAC0",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M37 23.6772C37.4017 22.1406 38.322 20.7725 39.6191 19.7837C40.9162 18.7948 42.5181 18.2401 44.1782 18.2049C45.8383 18.1697 47.4646 18.656 48.8064 19.5888C50.1483 20.5217 51.1314 21.8494 51.6044 23.3675",
                                    stroke: "white",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M44.6678 15.1797H43.9352C43.0173 15.1797 42.137 14.8319 41.4879 14.2129C40.8389 13.5938 40.4742 12.7543 40.4742 11.8788V11.5767C40.4742 10.6281 40.8693 9.71836 41.5726 9.04762C42.2759 8.37687 43.2297 8.00006 44.2243 8.00006C44.7377 7.99957 45.2462 8.09566 45.7206 8.28281C46.1951 8.46997 46.6262 8.74452 46.9892 9.09077C47.3522 9.43701 47.6401 9.84814 47.8364 10.3006C48.0326 10.7531 48.1333 11.2381 48.1328 11.7277V11.8788C48.1328 12.7543 47.7682 13.5938 47.1191 14.2129C46.47 14.8319 45.5897 15.1797 44.6718 15.1797H44.6678Z",
                                    stroke: "white",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                  },
                                }),
                                _vm._v(" "),
                                _c("path", {
                                  attrs: {
                                    d: "M18 16.4839L22.3077 21L30 11",
                                    stroke: "white",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$root.community.isMember
                      ? _c(
                          "a",
                          {
                            class: ["button__invite"],
                            attrs: {
                              "data-cy": "invite-to-community",
                              href: "#",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.showInvitePanel.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_c("p", [_vm._v("Invite")])]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "community__search" },
                [_c("community-search")],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "community__links" }, [
                _c(
                  "div",
                  { staticClass: "community__paging u-m-b4 u-m-b2@s" },
                  [
                    _c("router-link", {
                      attrs: { to: "/" + _vm.$root.community.url },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                          }) {
                            return [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: href },
                                    on: { click: navigate },
                                  },
                                  [
                                    _c(
                                      "h4",
                                      { class: [!isExactActive && "inactive"] },
                                      [
                                        _vm._v(
                                          "\n                                            All Posts\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      attrs: {
                        to: "/" + _vm.$root.community.url + "/official",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                          }) {
                            return [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: href },
                                    on: { click: navigate },
                                  },
                                  [
                                    _c(
                                      "h4",
                                      { class: [!isExactActive && "inactive"] },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "community__tab-full",
                                          },
                                          [_vm._v("Official posts")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "community__tab-short",
                                          },
                                          [_vm._v("Official")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      attrs: {
                        to: "/" + _vm.$root.community.url + "/articles",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                          }) {
                            return [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: href },
                                    on: { click: navigate },
                                  },
                                  [
                                    _c(
                                      "h4",
                                      { class: [!isExactActive && "inactive"] },
                                      [
                                        _vm._v(
                                          "\n                                            Articles\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      attrs: { to: "/" + _vm.$root.community.url + "/reposts" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({
                            href,
                            route,
                            navigate,
                            isActive,
                            isExactActive,
                          }) {
                            return [
                              _c("div", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: href },
                                    on: { click: navigate },
                                  },
                                  [
                                    _c(
                                      "h4",
                                      { class: [!isExactActive && "inactive"] },
                                      [
                                        _vm._v(
                                          "\n                                            Reposts\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "ModalWindow",
        {
          attrs: {
            "show-modal-window": _vm.showModalLeave,
            "close-event": _vm.closeLeaveModalEvent,
          },
        },
        [
          _vm.$root.community.isMember
            ? _c("div", [
                _c("img", {
                  staticClass: "u-a-center-i",
                  attrs: {
                    srcset: _vm.communityLogoSrcSet,
                    src: _vm.communityLogo,
                    alt: _vm.$root.community.name,
                    width: "60",
                    height: "60",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "modal-window__links u-a-center" }, [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.$root.community.name) + " Membership"),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "You have been a member since " +
                        _vm._s(
                          new Date(_vm.$root.community.joined).toDateString()
                        )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-window__source",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.leave.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("a", { attrs: { href: "#" } }, [
                      _vm._v("Leave the community?"),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }